// @ts-nocheck
import { Plugin } from 'F:/CNB工作台/xinguanjia_web_antdpro/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
